import React from 'react';
interface BaseProps {
  id: string;
  label: string;
  error?: string;
  children?: React.ReactNode;
}
const inputClasses = 'min-h-[52px] w-full border border-white/15 bg-white/[0.04] px-4 text-base text-white placeholder:text-white/35 focus:border-gold focus:outline-none';
export function FieldShell({
  id,
  label,
  error,
  children
}: BaseProps) {
  return <div data-id="element-133" data-mp="38oddyxr1gun7">
      <label htmlFor={id} className="mb-2 block text-xs font-semibold uppercase tracking-[0.14em] text-white/60" data-id="element-134" data-mp="aoe81fpgcnu">
        {label}
      </label>
      {children}
      {error ? <p id={`${id}-error`} role="alert" className="mt-1.5 text-sm text-kred" data-id="element-135" data-mp="3mhuz2mzdiffc">
          {error}
        </p> : null}
    </div>;
}
interface TextFieldProps extends BaseProps {
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'tel' | 'email';
  autoComplete?: string;
  inputMode?: 'text' | 'tel' | 'email';
}
export function TextField({
  id,
  label,
  error,
  value,
  onChange,
  type = 'text',
  autoComplete,
  inputMode
}: TextFieldProps) {
  return <FieldShell id={id} label={label} error={error} data-id="element-136" data-mp="2iwa40nmbs2pq">
      <input id={id} name={id} type={type} value={value} inputMode={inputMode} autoComplete={autoComplete} onChange={e => onChange(e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={inputClasses} data-id="element-137" data-mp="2etwxvy3o22sf" />
    </FieldShell>;
}
interface SelectFieldProps extends BaseProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  options: Array<{
    value: string;
    label: string;
  }>;
}
export function SelectField({
  id,
  label,
  error,
  value,
  onChange,
  placeholder,
  options
}: SelectFieldProps) {
  return <FieldShell id={id} label={label} error={error} data-id="element-138" data-mp="3lgsfq0hjhrgm">
      <select id={id} name={id} value={value} onChange={e => onChange(e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`${inputClasses} appearance-none`} data-id="element-139" data-mp="3lf7puo666wp3">
        <option value="" data-id="element-140" data-mp="3sl1uvdspd4ct">{placeholder}</option>
        {options.map(option => <option key={option.value} value={option.value} className="bg-ink" data-id="element-141" data-mp="1dfhuuk3fpja">
            {option.label}
          </option>)}
      </select>
    </FieldShell>;
}